module.exports = __webpack_public_path__ + "img/empty.c1c209a2.svg";